<template>
  <!-- Sort out shared links (US 9369 + 9371): activities linked to more than one process and contracts with more
       than one third party, from before each could have only one; and activities without a process -->
  <div class="sl-page" qid="shared-links">
    <header class="sx-hero sl-hero">
      <span class="sx-hero__logo is-process"><font-awesome-icon icon="link"/></span>
      <div class="sx-hero__main">
        <router-link :to="{ name: 'processes' }" class="sx-hero__back"><font-awesome-icon icon="angle-left"/>{{ $t('process_hero.crumb') }}</router-link>
        <h1 class="sx-hero__name">{{ $t('shared_links.title') }}</h1>
        <p class="sx-hero__text">{{ $t('shared_links.intro') }}</p>
      </div>
    </header>

    <nav class="sx-tabs mt-3" role="tablist">
      <button v-for="item in tabs" :key="item.key" type="button" role="tab" class="sx-tabs__tab" :class="{ on: tab === item.key }" @click="tab = item.key">
        <font-awesome-icon :icon="item.icon"/>{{ item.label }}<span class="sx-tabs__n">{{ item.count }}</span>
      </button>
    </nav>

    <section v-if="data" class="v2-card sp-sec mt-3">
      <template v-if="tab === 'activities'">
        <div v-for="item in data.activities" :key="item.id" class="sl-row" :qid="'shared-activity-' + item.id">
          <div class="sl-row__name">
            <b>{{ item.name }}</b>
            <small>{{ $t('shared_links.lives_in', { name: item.home ? item.home.name : '–' }) }}</small>
          </div>
          <div class="sl-row__links">
            <div v-for="process in item.shared" :key="process.id" class="sl-row__link">
              <span class="rk-applies is-process"><font-awesome-icon icon="sitemap"/>{{ $t('shared_links.also_in', { name: process.name }) }}</span>
              <b-button size="sm" variant="outline-secondary" :qid="'shared-activity-decide-' + item.id + '-' + process.id" @click="$refs.activityPanel.show(item, item.home, process)">{{ $t('parent_switcher.decide') }}</b-button>
            </div>
          </div>
        </div>
        <p v-if="!data.activities.length" class="sx-empty">{{ $t('shared_links.none') }}</p>
      </template>

      <template v-if="tab === 'contracts'">
        <div v-for="item in data.contracts" :key="item.id" class="sl-row" :qid="'shared-contract-' + item.id">
          <div class="sl-row__name">
            <b>{{ item.name }}</b>
            <small>{{ $t('shared_links.with', { name: item.home ? item.home.name : '–' }) }}</small>
          </div>
          <div class="sl-row__links">
            <div v-for="vendor in item.shared" :key="vendor.id" class="sl-row__link">
              <span class="rk-applies is-process"><font-awesome-icon icon="building"/>{{ $t('shared_links.also_with', { name: vendor.name }) }}</span>
              <b-button size="sm" variant="outline-secondary" :qid="'shared-contract-decide-' + item.id + '-' + vendor.id" @click="$refs.contractPanel.show(item, item.home, vendor)">{{ $t('parent_switcher.decide') }}</b-button>
            </div>
          </div>
        </div>
        <p v-if="!data.contracts.length" class="sx-empty">{{ $t('shared_links.none') }}</p>
      </template>

      <template v-if="tab === 'without'">
        <router-link v-for="item in data.without_process" :key="item.id" :to="{ name: 'activities.view', params: { slug: item.slug }, query: { tab: 'processes' } }" class="sl-row">
          <div class="sl-row__name"><b>{{ item.name }}</b><small>{{ $t('shared_links.no_process') }}</small></div>
          <span class="v2-link">{{ $t('shared_links.link') }} <font-awesome-icon icon="angle-right"/></span>
        </router-link>
        <p v-if="!data.without_process.length" class="sx-empty">{{ $t('shared_links.none') }}</p>
      </template>
    </section>

    <SharedLinkPanel ref="activityPanel" kind="activity" @decided="load"></SharedLinkPanel>
    <SharedLinkPanel ref="contractPanel" kind="contract" @decided="load"></SharedLinkPanel>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import SharedLinkPanel from '@/components/SharedLinkPanel.vue';

  export default {
    name: 'SharedLinks',
    components: { SharedLinkPanel },
    data() {
      return {
        data: null,
        // ?tab=contracts from the third parties list
        tab: ['activities', 'contracts', 'without'].includes(this.$route.query.tab) ? this.$route.query.tab : 'activities'
      };
    },
    computed: {
      getClient() {
        return this.$store.state.client;
      },
      tabs() {
        let data = this.data || { activities: [], contracts: [], without_process: [] };
        return [
          { key: 'activities', icon: 'sitemap', label: this.$t('shared_links.tabs.activities'), count: data.activities.length },
          { key: 'contracts', icon: 'building', label: this.$t('shared_links.tabs.contracts'), count: data.contracts.length },
          { key: 'without', icon: 'cube', label: this.$t('shared_links.tabs.without'), count: data.without_process.length }
        ];
      }
    },
    watch: {
      getClient(value, old) {
        if (value && (!old || value.slug !== old.slug)) {
          this.load();
        }
      }
    },
    created() {
      if (this.getClient && this.getClient.slug) {
        this.load();
      }
    },
    methods: {
      load() {
        let self = this;
        piincHttp.get('shared-links', { params: { client: this.getClient.slug } }).then(function(response) {
          self.data = response.data;
        }, function() {});
      }
    }
  };
</script>
